import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Typography from '@mui/material/Typography';
import React from 'react';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

const styles = {
    dialog: {
        '& div.MuiDialog-paper': {
            position: 'absolute',
            transform: 'translate(0%, -75%)',
            padding: '24px 36px !important',
        },
    },
    closeButton: {
        backgroundColor: 'rgba(90, 226, 136, 1) !important',
        borderRadius: '8px !important',
        '&:focus, &:active': {
            outline: 0,
            boxShadow: '0 0 0 0.2rem rgba(90, 226, 136, 0.25)',
        },
    },
    buttonTypography: {
        textTransform: 'none',
        color: '#174943',
        fontWeight: 'bold !important',
    },
};

type ValidationEmailDialogProps = {
    open: boolean;
    email: string;
    onClose: () => void;
};

const ValidationEmailDialog: React.FC<ValidationEmailDialogProps> = ({open, email, onClose}) => {
    return (
        <>
            <Dialog sx={styles.dialog} open={open} onClose={onClose} maxWidth="sm">
                <DialogTitle>
                    <Typography align="center">
                        <MailOutlineIcon fontSize="large" style={{color: '#5AE288'}} />
                    </Typography>
                    <Typography variant="h6" align="center">
                        <strong>Check your email</strong>
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText textAlign="center">
                        <Typography color="common.black">
                            We emailed a login link to <strong>{email}.</strong>
                            <br />
                            Click the link to log in.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <Grid container justifyContent="center">
                    <DialogActions>
                        <Button variant="contained" onClick={onClose} sx={styles.closeButton}>
                            <Typography sx={styles.buttonTypography}>Close</Typography>
                        </Button>
                    </DialogActions>
                </Grid>
            </Dialog>
        </>
    );
};

export default ValidationEmailDialog;
